import {
  Component,
  EventEmitter,
  Input,
  Output,
  forwardRef,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { FormInput } from '../_form-input';
import { v4 as uuid } from 'uuid';

@Component({
  selector: 'input-date',
  templateUrl: './input-date.component.html',
  styleUrls: ['./input-date.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputDateComponent),
      multi: true,
    },
  ],
})
export class InputDateComponent implements FormInput, ControlValueAccessor {
  @Input() value: any;
  @Input() id: string = uuid();
  @Input() name: string = 'id';
  @Input() label: string = 'Input';
  @Input() placeholder?: string;

  @Input() error: string = '';

  @Input() type: string = 'text';
  @Input() disabled: boolean = false;

  visibleValue: boolean = false;

  @Output() onChange$: EventEmitter<any> = new EventEmitter<any>();
  @Output() onFocus$: EventEmitter<void> = new EventEmitter<void>();
  @Output() focusOut$: EventEmitter<void> = new EventEmitter<void>();

  onChange: any = () => {};
  onTouched: any = () => {};

  writeValue(value: any): void {
    if (value !== undefined) {
      this.value = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  emitChange(value: any): void {
    this.value = value;
    this.onChange(value);
    this.onChange$.emit(value);
  }

  emitFocus(): void {
    this.onTouched();
    this.onFocus$.emit();
  }

  emitFocusOut(): void {
    this.focusOut$.emit();
  }
}
